module.exports = __webpack_public_path__ + "static/img/weitu-3.252d1d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weitu-3.png
// module id = R9R8
// module chunks = 0